export default "__VITE_PUBLIC_ASSET__f79d64d1__"